import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ResponsiveButton from "../ResponsiveButton/ResponsiveButton";
import { MdAddShoppingCart, MdRemoveShoppingCart, MdInfo, MdEventAvailable } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const ProductCard = ({
  item,
  addToCart,
  removeFromCart,
  cartItems,
  isBooked,
  isDisabled,
  hideCartButtons,
  hideQuantitySelector, // ➕ tämä lisättävä rivi
  hideAvailableCount, // 👈 lisää tämä

}) => {

  
  // Tarkistetaan, onko tuote korissa (localStorage- ja event-pohjaisesti)
  const [isInCart, setIsInCart] = useState(false);
  const navigate = useNavigate();

  // Lista tuotteista, jotka saavat aina näyttää määränvalitsimen ja "vuokrattavissa"-tekstin
const forceShowQuantity = [
  "600W db lavamonitori FM12",
  "ADJ Stinger Spot 30",
  "LED-valot Chauvet 56-24C",
  "Mikrofoni",
  "Mikrofoniteline"
];

const shouldForceShow = forceShowQuantity.includes(item?.name || item?.nimi);


  useEffect(() => {
    const checkCart = () => {
      const cart = JSON.parse(localStorage.getItem("rentalCart")) || [];
      const found = cart.some(cartItem => cartItem.id === item.id);
      setIsInCart(found);
    };

    checkCart();
    window.addEventListener("cartUpdated", checkCart);
    return () => window.removeEventListener("cartUpdated", checkCart);
  }, [item.id]);

  // Lasketaan korissa oleva määrä ja varastosaldo
  const quantityInCart = cartItems.reduce(
    (sum, cartItem) => (cartItem.id === item.id ? sum + cartItem.quantity : sum),
    0
  );
  const productStock = parseInt(item.available, 10) || 0;
  const availableTotal = productStock - quantityInCart;

  

  // Paikallinen tila määrän hallintaan
  const [localQuantity, setLocalQuantity] = useState(1);

  // Nollataan localQuantity, jos tuote ei ole korissa
  useEffect(() => {
    if (!isInCart) {
      setLocalQuantity(1);
    }
  }, [isInCart]);

  const isCameraPackage = !!item.onko_polaroid;
  const isAnyCameraInCart = cartItems.some(c => c.onko_polaroid);
  const shouldBeDimmed = isCameraPackage && isAnyCameraInCart && !isInCart;
  const isTrailer = item.id === 24;
  const finalDisable = isTrailer ? false : (isDisabled ?? false) || shouldBeDimmed;

  return (
    <div
      className={`bg-white bg-opacity-50 hover:bg-lightbg hover:bg-opacity-60 rounded-3xl relative group p-5 flex flex-col justify-between w-full transition-all ${
        finalDisable ? "opacity-50 pointer-events-none" : ""
      }`}
    >
      {!isTrailer && isBooked && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-[-10deg] bg-red-600 bg-opacity-100 text-white px-10 py-4 rounded-xl text-2xl font-bold shadow-xl z-50 animate-pulse">
          VARATTU
        </div>
      )}

      <div className="w-full h-[120px]">
        <Link
          to={item.link || "#"}
          title={item.name}
          onClick={() =>
            item.link && window.scrollTo({ top: 0, left: 0, behavior: "auto" })
          }
          aria-label={`Näytä ${item.name} tuotekuvaus`}
        >
          <img
            src={item.image || "assets/images/placeholder.jpg"}
            alt={item.name || "Ei kuvaa saatavilla"}
            className="w-full h-[120px] object-contain transition duration-700 cursor-pointer drop-shadow-[3px_3px_5px_rgba(0,0,0,0.80)]"
          />
        </Link>
      </div>

      <div className="flex flex-col justify-between flex-grow min-w-0 mt-2">
        <div className="grid grid-cols-1 place-items-center pt-2">
          <h3
            className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary text-sm xxxsm:text-[9px] xxsm:text-[12px] lg:text-[16px] font-bold uppercase"
            title={item.name}
          >
            {item.name || "Tuntematon tuote"}
          </h3>
        </div>

    {/* Näytetään saatavilla oleva määrä vain, jos varastossa on enemmän kuin 1 kappale */}
    {!hideAvailableCount && (shouldForceShow || availableTotal > 1) && (
  <div className="text-center mb-2">
    <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-[10px] xxsm:text-sm lg:text-xs font-bold mt-2">
      Vuokrattavissa: {availableTotal}
    </p>
  </div>
)}

        <div className="mt-auto text-center">
          <div className="font-customFont1 text-darkest dark:text-primary dark:text-shadow-lg font-normal pb-2">
            <p className="font-customFont1 text-center text-darkest dark:text-primary text-xl font-bold">
            <div className="font-customFont1 text-darkest dark:text-primary dark:text-shadow-lg font-normal pb-2">
              {item.slug !== "liity-vuokraajaksi" && (
                <p className="font-customFont1 text-center text-darkest dark:text-primary text-xl font-bold">
                  {item.price ? `${item.price} € / 24h` : "Hinta ei saatavilla"}
                </p>
              )}
            </div>

            </p>
          </div>

        {/* Näytetään määränvalitsin, jos varastossa on vähintään 1 kpl */}
      {/* Näytetään määränvalitsin vain, jos varastossa on enemmän kuin 1 kappale */}
      {!hideQuantitySelector && !isBooked && !finalDisable && (shouldForceShow || availableTotal > 1) && (

  <div className="flex justify-center items-center gap-2 mb-2">
    <button
      onClick={() => setLocalQuantity(prev => Math.max(1, prev - 1))}
      disabled={localQuantity <= 1}
      className="h-6 w-6 rounded-full bg-darkest text-primary font-normal flex items-center justify-center hover:bg-blue-900 dark:bg-violet dark:text-primary dark:hover:bg-blue-900 disabled:opacity-50 disabled:cursor-not-allowed"
      title="Vähennä määrää"
    >
      -
    </button>

    <span className="text-sm font-bold text-darkest dark:text-primary">
      {localQuantity}
    </span>

    <button
      onClick={() => setLocalQuantity(prev => Math.min(prev + 1, availableTotal))}
      disabled={localQuantity >= availableTotal}
      className="h-6 w-6 rounded-full bg-darkest text-primary font-normal flex items-center justify-center hover:bg-blue-900 dark:bg-violet dark:text-primary dark:hover:bg-blue-900 disabled:opacity-50 disabled:cursor-not-allowed"
      title="Lisää määrää"
    >
      +
    </button>
  </div>
)}

          {/* Add-to-cart -nappi: aina käytetään käyttäjän valitsemaa localQuantitya */}
          {!hideCartButtons && (
            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-3 mt-4 w-full">
            {item.slug === "liity-vuokraajaksi" ? null : (
              !item.onko_polaroid && !isTrailer && quantityInCart < productStock ? (
                <ResponsiveButton
                  onClick={() => {
                    addToCart(item, localQuantity);
                    setLocalQuantity(1);
                  }}
                  disabled={availableTotal <= 0 || isBooked}
                  icon={MdAddShoppingCart}
                  variant="productcardaddtocart"
                  className="min-w-[130px] text-sm"
                >
                  Lisää koriin
                </ResponsiveButton>
              ) : item.onko_polaroid ? (
                <p className="font-customFont1 text-sm text-darkest dark:text-shadow-lg dark:text-primary font-normal">
                  Katso kamerapaketit lisätiedot-sivulta
                </p>
              ) : null
            )}



              {isInCart && (
                <ResponsiveButton
                  onClick={() => removeFromCart(item)}
                  icon={MdRemoveShoppingCart}
                  variant="productcardremovefromcart"
                  className="min-w-[130px] text-sm"
                >
                  Poista korista
                </ResponsiveButton>
              )}

              {isTrailer ? (
                <>
                  <ResponsiveButton
                    onClick={() => {
                      navigate(`/tuote/${item.slug}#kalenteri`);
                    }}
                    icon={MdEventAvailable}
                    variant="productcarddetails"
                    className="min-w-[160px] text-sm"
                  >
                    Vuokrauskalenteri
                  </ResponsiveButton>

                  <ResponsiveButton
                    onClick={() => {
                      if (item.slug === "liity-vuokraajaksi") {
                        navigate("/palvelut#liity-vuokraajaksi");
                        setTimeout(() => {
                          const el = document.querySelector("#liity-vuokraajaksi");
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth", block: "start" });
                          }
                        }, 300);
                      } else {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        navigate(`/tuote/${item.slug}`);
                      }
                    }}
                    icon={MdInfo}
                    variant="productcarddetails"
                    className="min-w-[130px] text-sm"
                  >
                    Lisätiedot
                  </ResponsiveButton>
                </>
              ) : (
                item.slug && item.slug.trim() !== "" && (
                  <ResponsiveButton
                  onClick={() => {
                    if (item.slug === "liity-vuokraajaksi") {
                      navigate("/palvelut#liity-vuokraajaksi");
                      setTimeout(() => {
                        const el = document.querySelector("#liity-vuokraajaksi");
                        if (el) {
                          el.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                      }, 300);
                    } else {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      navigate(`/tuote/${item.slug}`);
                    }
                  }}
                  icon={MdInfo}
                  variant="productcarddetails"
                  className="min-w-[130px] text-sm"
                >
                  Lisätiedot
                </ResponsiveButton>
                
                )
              )}
            </div>
          )}
        </div>
      </div>
      {item.vuokraaja && (
        <div className="mt-2 text-center">
          <p className="font-customFont1 text-sm text-darkest dark:text-primary dark:text-shadow-lg">
            Vuokraaja: <strong>{item.vuokraaja}</strong>
          </p>
        </div>
      )}
      
      {item.sijainti && (
        <div className="mt-4 text-center">
          <p className="font-customFont1 text-lg text-darkest dark:text-primary dark:text-shadow-lg">
            📍 {item.sijainti}
          </p>
        </div>
        
      )}
    </div>
  );
};

ProductCard.propTypes = {
  item: PropTypes.object.isRequired,
  addToCart: PropTypes.func, // ei enää .isRequired
  removeFromCart: PropTypes.func, // ei enää .isRequired
  cartItems: PropTypes.array.isRequired,
  isBooked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  hideCartButtons: PropTypes.bool,
  hideQuantitySelector: PropTypes.bool,
  hideAvailableCount: PropTypes.bool,
  

};


export default ProductCard;
